import { render } from "./calendar-outlined.vue?vue&type=template&id=c3e08792"
import script from "./calendar-outlined.vue?vue&type=script&lang=js"
export * from "./calendar-outlined.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__